import { createContext } from 'react';

import { AppFlags } from '../client/config';

const FlagsContext = createContext<AppFlags>({
  enableDonateToTeam: false,
  enableOtgVideoChat: false,
  useCutterForSocialSharing: false,
  virtualFitnessEventsDebugFeatures: false,
  virtualFitnessEventsPreview: false,
  useLeaderboardFundraisersList: false,
  useLeaderboardFundraisersListForTeams: false,
  useLeaderboardTeamsListForCampaign: false,
  useOTGVideoGenerator: false,
  useOnePageForFundraisingPages: false,
  useOnePageForCampaignPages: false,
  showTeamCreationCTAForOnePage: false,
  enableFitbit: false,
  enableSupportersService: false,
  enableVerifiedBanner: false,
  showFrpSetReminderButton: false,
});

export default FlagsContext;
FlagsContext.displayName = 'FlagsContext';

export const FlagsProvider = FlagsContext.Provider;
export const FlagsConsumer = FlagsContext.Consumer;
